export class PerimeterDto {
  public readonly canAccess: boolean = false;
  public readonly canEdit: boolean = false;

  public constructor(canAccess: boolean = false, edit: boolean = false) {
    this.canAccess = canAccess;
    this.canEdit = edit;
  }
}
